import React, { createContext, useCallback, useContext, useEffect, useState, } from 'react';
export var CompactViewContext = createContext(typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.innerWidth) < 992);
export var useIsCompact = function () {
    return useContext(CompactViewContext);
};
export var CompactViewProvider = function (_a) {
    var children = _a.children;
    var _b = useState(typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.innerWidth) < 992), isCompact = _b[0], setIsCompact = _b[1];
    var handleResize = useCallback(function () {
        setIsCompact(typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.innerWidth) < 992);
    }, []);
    useEffect(function () {
        window.addEventListener('resize', handleResize, false);
        return function () {
            window.removeEventListener('resize', handleResize, false);
        };
    }, [handleResize]);
    return (React.createElement(CompactViewContext.Provider, { value: isCompact }, children(isCompact)));
};
